'use client';

import React, { useState } from 'react';

interface QuizProgressSectionProps {
  progressPercentage: number;
  children: React.ReactNode;
  type?: 'quiz' | 'assessment';
}

export function QuizProgressSection({
  progressPercentage,
  children,
  type = 'quiz',
}: QuizProgressSectionProps) {
  const [showDetails, setShowDetails] = useState(true);
  const isComplete = progressPercentage === 100;
  const progressBarClass = isComplete 
    ? 'h-1 rounded-full bg-amethyst-accent transition-all duration-300 quiz-progress-bar-complete' 
    : 'h-1 rounded-full bg-amethyst-accent transition-all duration-300';
  
  const headingText = type === 'assessment' ? 'Assessment Progress' : 'Quiz Progress';
  const labelText = type === 'assessment' ? 'Assessment' : 'Quiz';

  return (
    <div className="bg-gradient-sheen rounded-lg flex flex-col overflow-hidden">
      <div className="quiz-progress-header rounded-t-lg py-4 ps-[22px] pe-6">
        <div className="flex items-center justify-between mb-2">
          <h6 className="cs-h4">{headingText}</h6>
        </div>
        <div className="bg-surface-5 h-1 rounded-full">
          <div
            className={progressBarClass}
            style={{ width: `${progressPercentage}%` }}
          ></div>
        </div>
        <div className="cs-caption mb-0 mt-1 flex items-center justify-between">
          <span>
            {labelText}:{' '}
            <span className="text-amethyst-accent">
              {progressPercentage}%
            </span>
            {' '}Complete
          </span>
          <button
            className="cs-caption text-text-action-medium hover:text-text-action-strong bg-transparent border-0 cursor-pointer p-0"
            onClick={() => setShowDetails(!showDetails)}
          >
            {showDetails ? 'Show less' : 'Show more'}
          </button>
        </div>
      </div>
      {/* Questions list - toggle visibility */}
      {showDetails && (
        <div className="quiz-questions-section">
          {children}
        </div>
      )}
    </div>
  );
}

